import React, { FC, useState } from 'react'
import styles from './PublicOrder.module.css'
import noImage from '../../assets/img/no-image.jpg'
import arrow from '../../assets/icons/IconArrowDownBlue.svg'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import trashGray from '../../assets/icons/trashGray.svg'
import CustomButton from '../UI/CustomButton/CustomButton'
import {
  removeProductFromOrder,
  updateProductQuantity,
} from '../../redux/reducers/publicOrder/publicOrderSlice'
import { useToast } from '../../context/ToastContext'
import { ProductType } from '../../redux/actions/types'

export type OrderedDishesListCardPropsType = {
  handleNextTab: () => void
}

const PublicOrder: FC<OrderedDishesListCardPropsType> = ({ handleNextTab }) => {
  const [openMore, setOpenMore] = useState(false)
  const { showSuccess } = useToast()
  const { items: publicOrderItems, totalPrice } = useAppSelector((state) => state.publicOrder)
  const dispatch = useAppDispatch()

  const handleRemoveProduct = (productId: number) => {
    dispatch(removeProductFromOrder(productId))
    showSuccess('Товар удален из заказа')
  }

  const onCountChange = (e: React.ChangeEvent<HTMLInputElement>, item: any) => {
    const val = Number(e.target.value)
    if (val >= 1) {
      dispatch(updateProductQuantity({ productId: item.productId, quantity: val }))
    }
  }

  const handleIncrease = (item: any) => {
    dispatch(updateProductQuantity({ productId: item.productId, quantity: item.quantity + 1 }))
  }

  const handleDecrease = (item: any) => {
    if (item && item.quantity > 1) {
      dispatch(updateProductQuantity({ productId: item.productId, quantity: item.quantity - 1 }))
    }
  }

  const handleSubmit = () => {
    if (publicOrderItems.length > 0) {
      handleNextTab()
    }
  }
  if (publicOrderItems.length === 0) {
    return null
  }

  return (
    <div className={styles.OrderedDishesListCard}>
      <div className={styles.formContainer}>
        <h1 className={styles.title}>Состав Заказа</h1>
        <div className={styles.content}>
          {publicOrderItems.map((item) => (
            <div key={item.productId} className={styles.dishCard}>
              <div className={styles.nameContainer}>
                <div className={styles.left}>
                  {item?.images?.length > 0 ? (
                    <div className={styles.imagesContainer}>
                      <img
                        src={`${process.env.REACT_APP_BASE_URL_IMAGES}${item.images[0]}`}
                        alt={''}
                        className={styles.dishImage}
                      />
                    </div>
                  ) : (
                    <div className={styles.imagesContainer}>
                      <img src={noImage} alt={''} className={styles.dishImage} />
                    </div>
                  )}
                  <h2>{item?.name}</h2>
                </div>
                <button
                  className={styles.deleteButton}
                  onClick={() => handleRemoveProduct(item.productId)}
                >
                  <img className={styles.icon} src={trashGray} alt='icon' />
                </button>
              </div>
              <div className={styles.right}>
                <div className={styles.control}>
                  <CustomButton
                    className={styles.countButton}
                    title='-'
                    onClick={() => handleDecrease(item)}
                  />
                  <input
                    min={1}
                    value={item.quantity === 0 ? '' : item.quantity}
                    onChange={(e) => onCountChange(e, item)}
                    className={styles.countInput}
                  />
                  <CustomButton
                    className={styles.countButton}
                    title='+'
                    onClick={() => handleIncrease(item)}
                  />
                </div>

                <h3 className={styles.priceText}>
                  {item.quantity}X{item.price} руб
                </h3>
              </div>
            </div>
          ))}
        </div>

        {publicOrderItems.length > 0 && (
          <div className={styles.orderInfoContainer}>
            <div className={styles.totalPriceContainer}>
              <span className={styles.totalPriceTitle}>Итоговая сумма заказа</span>
              <span className={styles.totalPrice}>{totalPrice} руб</span>
            </div>
            <div className={styles.moreContainer}>
              <div onClick={() => setOpenMore(!openMore)} className={styles.moreWrapper}>
                <img src={arrow} />
                <span className={styles.moreTitle}>{openMore ? 'Свернуть' : 'Подробнее'}</span>
              </div>
              {openMore && (
                <>
                  <div className={styles.moreItemInfo}>
                    <span className={styles.leftSide}>Количество товаров</span>
                    <span className={styles.rightSide}>{publicOrderItems.length} шт</span>
                  </div>
                  <div className={styles.moreItemInfo}>
                    <span className={styles.leftSide}>Сумма заказа</span>
                    <span className={styles.rightSide}>{totalPrice} руб</span>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        <div className={styles.saveButtonBlock}>
          <CustomButton
            disabled={publicOrderItems.length === 0}
            className={styles.addSiteBtn}
            title='Далее'
            type='button'
            onClick={handleSubmit}
          />
        </div>
      </div>
    </div>
  )
}

export default PublicOrder
